import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
  TextField,
  Button,
  Stack,
  Checkbox,
  FormControlLabel,
  Alert,
  Snackbar,
  useTheme,
  alpha,
  List,
  ListItem,
  ListItemText,
  IconButton,
} from "@mui/material";
// import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessIcon from "@mui/icons-material/Business";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link, useLocation } from "react-router-dom";
import img from "./images/Kurdish Translation Services.png";
import Footer from "../Components/Footer";
import ScrollToTop from "../Components/ScrollToTop";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const Book_now = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const [full_name, setFullname] = useState("");
  const [phone_number, setphone_number] = useState("");
  const [email, setemail] = useState("");
  const [country, setcountry] = useState("");
  const [subject, setsubject] = useState("");
  const [instructions, setinstructions] = useState("");
  const [files, setFiles] = useState([]);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const Get_Api = async () => {
    try {
      let api = "https://api.kurdishtranslationservices4u.co.uk/api/bookings";
      const response = await fetch(api);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
    } catch (error) {
      // Silently handle the error - API might be unavailable or CORS issue
      console.warn("API check failed:", error.message);
    }
  };
  const direction = ["ku"].includes(i18n.language) ? "rtl" : "ltr";
  const textAlign = ["ku"].includes(i18n.language) ? "right" : "left";
  useEffect(() => {
    Get_Api();
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!full_name.trim()) {
      newErrors.full_name = "Please input your Full Name";
    }
    if (!phone_number.trim()) {
      newErrors.phone_number = "Please input your Phone Number";
    }
    if (!email.trim()) {
      newErrors.email = "Please input your Email";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Please input a valid email";
    }
    if (!country.trim()) {
      newErrors.country = "Please input your Country";
    }
    if (!subject.trim()) {
      newErrors.subject = "Please input your Subject";
    }
    if (!instructions.trim()) {
      newErrors.instructions = "Please input your Instructions";
    }
    if (files.length === 0) {
      newErrors.files = "Please upload at least one file";
    }
    if (!privacyAccepted) {
      newErrors.privacy = "Please accept the privacy policy";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const Post_Api = async () => {
    if (!validateForm()) {
      setSnackbar({
        open: true,
        message: "Please fill in all required fields",
        severity: "error",
      });
      return;
    }

    const URI = "https://api.kurdishtranslationservices4u.co.uk/api/bookings";

    try {
      let formData = new FormData();

      formData.append("full_name", full_name);
      formData.append("phone_number", phone_number);
      formData.append("email", email);
      formData.append("country", country);
      formData.append("subject", subject);
      formData.append("instructions", instructions);

      files.forEach((file, index) => {
        // formData.append(`files[${index}]`, file.originFileObj);
        formData.append(`files[${index}]`, file);
      });

      let res = await fetch(URI, {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }

      res = await res.json();
      setSnackbar({
        open: true,
        message: "Form submitted successfully",
        severity: "success",
      });
      handleReset();
    } catch (error) {
      console.error("Error:", error);
      setSnackbar({
        open: true,
        message: "Failed to submit form. Please try again later.",
        severity: "error",
      });
    }
  };

  const handleReset = () => {
    setFullname("");
    setphone_number("");
    setemail("");
    setcountry("");
    setsubject("");
    setinstructions("");
    setFiles([]);
    setPrivacyAccepted(false);
    setErrors({});
  };

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    setFiles([...files, ...selectedFiles]);
  };

  const handleRemoveFile = (index) => {
    setFiles(files.filter((_, i) => i !== index));
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Box sx={{ minHeight: "100vh" }}>
      {/* Hero Section */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          py: { xs: 6, md: 10 },
          mt: { xs: 7, sm: 8 },
          position: "relative",
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)",
          },
        }}
      >
        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: 32, md: 48 },
              fontWeight: 700,
              color: "white",
              textAlign: "center",
              mb: 3,
              textShadow: "0 2px 10px rgba(0,0,0,0.2)",
            }}
          >
            {t("BookNowTop")}
          </Typography>
        </Container>
      </Box>

      {/* Intro Text (similar style to AboutUs) */}
      <Container
        maxWidth="lg"
        sx={{ mt: { xs: 6, md: 8 }, mb: 4, px: { xs: 2, md: 4 } }}
      >
        <Paper
          elevation={0}
          sx={{
            padding: { xs: 4, md: 6 },
            borderRadius: 4,
            background:
              "linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)",
            border: "1px solid",
            borderColor: alpha(theme.palette.primary.main, 0.1),
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: 18, md: 22 },
              fontWeight: 400,
              lineHeight: 1.8,

              color: "text.primary",
              whiteSpace: "pre-line",
              direction,
              textAlign,
            }}
          >
            {t("PageBookNowTitle")}
          </Typography>
        </Paper>
      </Container>

      {/* Main Content */}
      <Container
        maxWidth="lg"
        sx={{ mt: { xs: 6, md: 8 }, mb: 8, px: { xs: 2, md: 4 } }}
      >
        <Grid container spacing={4}>
          {/* Form Section */}
          <Grid item xs={12} md={8}>
            <Paper
              elevation={0}
              sx={{
                padding: { xs: 3, md: 4 },
                borderRadius: 4,
                background:
                  "linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)",
                border: "1px solid",
                borderColor: alpha(theme.palette.primary.main, 0.1),
              }}
            >
              <Stack spacing={3}>
                <TextField
                  label={t("FullName")}
                  value={full_name}
                  onChange={(e) => setFullname(e.target.value)}
                  placeholder={t("One")}
                  fullWidth
                  required
                  error={!!errors.full_name}
                  helperText={errors.full_name}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />

                <TextField
                  label={t("Phone")}
                  value={phone_number}
                  onChange={(e) => setphone_number(e.target.value)}
                  placeholder={t("Two")}
                  fullWidth
                  required
                  error={!!errors.phone_number}
                  helperText={errors.phone_number}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />

                <TextField
                  label={t("Email")}
                  type="email"
                  value={email}
                  onChange={(e) => setemail(e.target.value)}
                  placeholder={t("Three")}
                  fullWidth
                  required
                  error={!!errors.email}
                  helperText={errors.email}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />

                <TextField
                  label={t("YourCountry")}
                  value={country}
                  onChange={(e) => setcountry(e.target.value)}
                  placeholder={t("Four")}
                  fullWidth
                  required
                  error={!!errors.country}
                  helperText={errors.country}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />

                <TextField
                  label={t("Subject")}
                  value={subject}
                  onChange={(e) => setsubject(e.target.value)}
                  placeholder={t("Five")}
                  fullWidth
                  required
                  error={!!errors.subject}
                  helperText={errors.subject}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />

                <TextField
                  label={t("Instructions")}
                  value={instructions}
                  onChange={(e) => setinstructions(e.target.value)}
                  multiline
                  rows={4}
                  fullWidth
                  required
                  error={!!errors.instructions}
                  helperText={errors.instructions}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />

                {/* File Upload */}
                <Box>
                  <Typography
                    variant="body2"
                    sx={{ mb: 1, fontWeight: 500, color: "text.primary" }}
                  >
                    {t("Upload")}{" "}
                    {files.length > 0 && `(${files.length} files)`}
                  </Typography>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<UploadFileIcon />}
                    sx={{
                      borderRadius: 2,
                      mb: files.length > 0 ? 2 : 0,
                    }}
                  >
                    {t("UploadClick")}
                    <input
                      type="file"
                      hidden
                      multiple
                      onChange={handleFileChange}
                    />
                  </Button>
                  {errors.files && (
                    <Typography
                      variant="caption"
                      sx={{ color: "error.main", display: "block", mt: 0.5 }}
                    >
                      {errors.files}
                    </Typography>
                  )}
                  {files.length > 0 && (
                    <List
                      sx={{
                        mt: 2,
                        border: "1px solid",
                        borderColor: alpha(theme.palette.divider, 0.5),
                        borderRadius: 2,
                        bgcolor: "background.paper",
                      }}
                    >
                      {files.map((file, index) => (
                        <ListItem
                          key={index}
                          secondaryAction={
                            <IconButton
                              edge="end"
                              onClick={() => handleRemoveFile(index)}
                              color="error"
                            >
                              <DeleteIcon />
                            </IconButton>
                          }
                        >
                          <ListItemText
                            primary={file.name || file}
                            secondary={
                              file.size
                                ? `${(file.size / 1024).toFixed(2)} KB`
                                : ""
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  )}
                </Box>

                {/* Privacy Policy Checkbox */}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={privacyAccepted}
                      onChange={(e) => setPrivacyAccepted(e.target.checked)}
                      sx={{
                        color: errors.privacy ? "error.main" : "primary.main",
                      }}
                    />
                  }
                  label={
                    <Typography variant="body2">
                      I accept{" "}
                      <Link
                        to="/PrivacyPolicy"
                        style={{
                          color: theme.palette.primary.main,
                          textDecoration: "none",
                        }}
                      >
                        The privacy policy
                      </Link>{" "}
                      for the use of this website.
                    </Typography>
                  }
                />
                {errors.privacy && (
                  <Typography
                    variant="caption"
                    sx={{ color: "error.main", ml: 4 }}
                  >
                    {errors.privacy}
                  </Typography>
                )}

                <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                  <Button
                    variant="contained"
                    onClick={Post_Api}
                    sx={{
                      flex: 1,
                      py: 1.5,
                      borderRadius: 2,
                      background:
                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                      "&:hover": {
                        background:
                          "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                        transform: "translateY(-2px)",
                        boxShadow: "0 6px 20px rgba(102, 126, 234, 0.6)",
                      },
                    }}
                  >
                    {t("Submit")}
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleReset}
                    sx={{
                      flex: 1,
                      py: 1.5,
                      borderRadius: 2,
                    }}
                  >
                    {t("Reset")}
                  </Button>
                </Stack>
              </Stack>
            </Paper>
          </Grid>

          {/* Contact Info Section */}
          <Grid item xs={12} md={4}>
            <Paper
              elevation={0}
              sx={{
                padding: { xs: 3, md: 4 },
                borderRadius: 4,
                background:
                  "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
                border: "1px solid",
                borderColor: alpha(theme.palette.primary.main, 0.2),
                height: "100%",
              }}
            >
              <Box sx={{ textAlign: "center", mb: 4 }}>
                <Box
                  component="img"
                  src={img}
                  alt="Logo"
                  sx={{
                    maxWidth: "100%",
                    height: "auto",
                    maxHeight: 60,
                  }}
                />
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1.5,
                    p: 2,
                    borderRadius: 2,
                    background: "rgba(255, 255, 255, 0.5)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      background: "rgba(255, 255, 255, 0.7)",
                      transform: "translateX(4px)",
                    },
                  }}
                >
                  <LocationOnIcon
                    sx={{
                      color: "primary.main",
                      mt: 0.5,
                      fontSize: { xs: 24, md: 28 },
                    }}
                  />
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: 16, md: 18 },
                        mb: 0.5,
                        color: "text.primary",
                      }}
                    >
                      30 Bracknell Crescent
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: { xs: 15, md: 17 },
                        color: "text.secondary",
                        lineHeight: 1.6,
                      }}
                    >
                      Nottingham
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: { xs: 15, md: 17 },
                        color: "text.secondary",
                        lineHeight: 1.6,
                      }}
                    >
                      NG8 5FF
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: { xs: 15, md: 17 },
                        color: "text.secondary",
                        lineHeight: 1.6,
                        fontWeight: 500,
                      }}
                    >
                      United Kingdom
                    </Typography>
                  </Box>
                </Box>

                {/* <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    p: 2,
                    borderRadius: 2,
                    background: "rgba(255, 255, 255, 0.5)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      background: "rgba(255, 255, 255, 0.7)",
                      transform: "translateX(4px)",
                    },
                  }}
                >
                  <PhoneIcon
                    sx={{
                      color: "primary.main",
                      fontSize: { xs: 24, md: 28 },
                    }}
                  />
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: 16, md: 18 },
                      color: "text.primary",
                    }}
                  >
                    +44 7751655145
                  </Typography>
                </Box> */}

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    p: 2,
                    borderRadius: 2,
                    background: "rgba(255, 255, 255, 0.5)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      background: "rgba(255, 255, 255, 0.7)",
                      transform: "translateX(4px)",
                    },
                  }}
                >
                  <EmailIcon
                    sx={{
                      color: "primary.main",
                      fontSize: { xs: 24, md: 28 },
                    }}
                  />
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: 16, md: 18 },
                      color: "text.primary",
                    }}
                  >
                    contact@kts4u.co.uk
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    p: 2,
                    borderRadius: 2,
                    background: "rgba(255, 255, 255, 0.5)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      background: "rgba(255, 255, 255, 0.7)",
                      transform: "translateX(4px)",
                    },
                  }}
                >
                  <BusinessIcon
                    sx={{
                      color: "primary.main",
                      fontSize: { xs: 24, md: 28 },
                    }}
                  />
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: 16, md: 18 },
                      color: "text.primary",
                    }}
                  >
                    Company Number: 15568153
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>

      {/* Scroll to Top Button */}
      <ScrollToTop />

      <Footer />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Book_now;
